import React, { createContext, useContext, useState } from "react";

const NavDirectionContext = createContext(null);

export function NavDirectionProvider({ children }) {
  const [dir, setDir] = useState("up");
  return (
    <NavDirectionContext.Provider value={{ dir, setDir }}>
      {children}
    </NavDirectionContext.Provider>
  );
}

export function useNavDirection() {
  const ctx = useContext(NavDirectionContext);
  if (!ctx) throw new Error("useNavDirection must be used within NavDirectionProvider");
  return ctx;
}
